module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "onboarding-tours": "static-1.16913"
    },
    "depPathPrefixes": {
      "onboarding-tours": "/onboarding-tours/static-1.16913"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.33967",
    "project": "onboarding-tours",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};